module.exports = __webpack_public_path__ + "static/img/cz1.1f4b952.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cz1.png
// module id = 55
// module chunks = 0